<template>
    <v-alert v-if="rejected.length" type="warning" outlined prominent border="left" class="mb-6">
        <div class="font-weight-medium mb-1">
            {{ rejected.length }} tracked {{ rejected.length === 1 ? 'session was' : 'sessions were' }}
            removed from your totals by a manager
        </div>
        <ul class="pl-4 mb-0">
            <li v-for="s in rejected" :key="s.id" class="text-body-2">
                {{ $date(s.started_at).format('D MMM YYYY HH:mm') }} · {{ formatDuration(s.duration_seconds) }}
                <span v-if="s.review_note"> — {{ s.review_note }}</span>
                <span v-else class="grey--text"> — no reason given</span>
            </li>
        </ul>
    </v-alert>
</template>

<script>
export default {
    name: 'MyRejectedSessions',

    data() {
        return { rejected: [] };
    },

    mounted() {
        this.load();
    },

    methods: {
        async load() {
            try {
                const res = await this.$axios.get('api/agent/my-session-reviews');
                if (res.data?.response) this.rejected = res.data.rejected;
            } catch (e) {
                this.rejected = [];
            }
        },

        formatDuration(seconds) {
            const h = Math.floor(seconds / 3600);
            const m = Math.floor((seconds % 3600) / 60);
            return h ? `${h}h ${m}m` : `${m}m`;
        },
    },
};
</script>
